import { ApplyStatusType, JOHOKU_ACCOUNT, JOHOKU_ACCOUNT_TYPE } from "enums";
import { ApplyItemDetailModel, CorpInfoModel } from "models";

export function createCorpInfoData() {
  const tmp: CorpInfoModel = {
    corp_name: "",
    corp_name_kana: "",
    representative_name: "",
    is_personal: false,
    corp_no: "",
    invoice_no: "",
    industry_major_cd: "",
    industry_middle_cd: "",

    post_no1: "",
    post_no2: "",
    prefecture_cd: "",
    address: "",
    citytown: "",
    tel_no: "",
    fax_no: "",
    corp_mail_address: "",
    corp_url: "",
    establishment_date: "",
    capital_cd: "",
    employees_number_cd: "",
    yearly_sales_cd: "",
    order_limit: "",
    nyu_month: 1,
    nyu_day: 31,

    has_johoku_account: true,

    bank_account_list: [
      {
        bank_cd: JOHOKU_ACCOUNT.bank_cd,
        bank_name: JOHOKU_ACCOUNT.bank_name,
        branch_cd: "",
        branch_name: "",
        account_type: 1,
        account_no: "",
        account_name: "",
        johoku_account_type: JOHOKU_ACCOUNT_TYPE.HAS_ACCOUNT,
      },
    ],
  };
  return tmp;
}

/** 出品商品データの空データ作成 */
export function createApplyItemDetailData() {
  const tmp: ApplyItemDetailModel = {
    apply_item_cd: null,
    /** 販売ステータス (1：販売中, 2：販売停止, null：未登録) */
    sale_status: null,
    /** 申請ステータス (0：承認待ち, 1：承認済み, 2：否認, 3：即時承認)*/
    apply_status: ApplyStatusType._0_WAIT,
    apply_item_name: "",
    apply_item_main_image: {
      file_name: "",
      file_data: "",
      image_url: "",
    },
    apply_item_sub_image: [],
    apply_jan_code: "",
    apply_item_category: [
      {
        apply_item_large_category_id: "",
        apply_item_medium_category_id: "",
        apply_item_small_category_id: "",
      },
    ],
    apply_item_description: "",
    apply_item_append_pdf: {
      file_name: "",
      file_data: "",
      image_url: "",
    },
    /** 公開範囲設定リスト種別 (limited：限定公開リスト, hide：非公開リスト) */
    list_type: null,
    list_id: "",
    apply_is_discretionary_price: false,
    apply_unit_price: "",
    /** 課税区分 (1：課税（標準）, 2：非課税, 3：対象外, 4：課税（軽減）, 5：課税（共通返還）)*/
    apply_ctax_type: null,
    apply_recommend_item: [],
    apply_tag: [],
    apply_item_note: "",
    apply_deny_reason: "",
    apply_comment: "",
  };
  return tmp;
}
